import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --primary-color: #D4A017;
    --secondary-color: #B8860B;
    --accent-color: #F5F0E8;
    --text-color: #1C1511;
    --light-bg: #FAF8F3;
    --white: #FFFFFF;
    --gray-light: #F5F5F5;
    --gray-medium: #CCCCCC;
    --gray-dark: #666666;
    --error: #FF4444;
    --success: #44BB44;
    --warning-color: #D97706;
    --warning-bg: #FEF3C7;
    --warning-border: #FBBF24;

    --breakpoint-mobile: 320px;
    --breakpoint-tablet: 768px;
    --breakpoint-desktop: 1024px;
    --breakpoint-large: 1440px;

    --max-content-width: 1440px;
    --header-height: 60px;
    --mobile-nav-height: 60px;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text-color);
    background-color: var(--light-bg);
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: Georgia, 'Times New Roman', serif;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: clamp(1.5rem, 5vw, 2.5rem);
  }

  h2 {
    font-size: clamp(1.25rem, 4vw, 2rem);
  }

  h3 {
    font-size: clamp(1.1rem, 3vw, 1.5rem);
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button, a {
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  button {
    min-height: 44px;
    min-width: 44px;
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    min-height: 44px;
  }

  .container {
    width: 100%;
    max-width: var(--max-content-width);
    margin: 0 auto;
    padding: 0 1rem;

    @media (min-width: 768px) {
      padding: 0 2rem;
    }

    @media (min-width: 1024px) {
      padding: 0 3rem;
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;

export default GlobalStyles;